import React, {Component, useEffect, useState} from 'react'
import PropTypes from 'prop-types'

import styles from '../Result.module.css'
import {useHistory, useLocation} from 'react-router'
import ResultSuccess from '../ResultSucces'
import ResultFail from '../ResultFail'
import {Header, Image, Modal, Segment} from "semantic-ui-react";
import {API_BASE} from "../../config/env";
import {ADV_TYPE_OFFER, ADV_TYPE_RECEIPT} from "../../constants";
import axios from "axios";
import Order from "../Order";
import {PAYCELL_LOGO} from '../../constants'
import Helper from "../Helper";
import Footer from "../Footer";
import PageHeader from "../Header";

function Result() {
  let history = useHistory()

    const [paymentResult, setPaymentResult] = useState('');
    const [invoice, setInvoice] = useState('')
    const [receiptAdv, setReceiptAdv] = useState('');
    const [showReceiptAdv, setShowReceiptAdv] = useState(false);
    const [offer, setOffer] = useState('');
    const [showOffer, setShowOffer] = useState(false);
    const [orderActive, setOrderActive] = useState(false);
    const [openOrderModal, setOpenOrderModal] = useState(false);
    const { getButtonStyle , isExternalSdk, getStorageItem,getStorageItemAsValue} = Helper();
    const [receiptImage ,  setReceiptImage] = useState([]);
    const [offerImage ,  setOfferImage] = useState([]);

    useEffect(async () => {
        await setImages();
        setInvoice(history.location.state.invoice);
        setPaymentResult(history.location.state.paymentResult);
        window.scrollTo(0, 0);
    }, [])

    const setImages = async () => {
        setReceiptImage(getStorageItem("receipt"));
        setOfferImage(getStorageItem("offer"));

        if(offerImage !== null)
            setShowOffer(true)
        else
            setShowOffer(false)


        const orderEnableParam = getStorageItemAsValue("orderEnable");
        if (orderEnableParam !== null && orderEnableParam ==='1')
            setOrderActive(true);
         else
            setOrderActive(false);
    }


    const handleCloseOrderModal = () => {
        setOpenOrderModal(!openOrderModal);
    };

  return (
    <div>

      <PageHeader className='header'/>

      <Modal
            style={{maxWidth:'1000px'}}
            closeOnDimmerClick={false}
            open={openOrderModal}
            onClose={() => setOpenOrderModal(false)}
            onOpen={() => setOpenOrderModal(true)}
            id='my-modal'>
            <Modal.Header>
                Otomatik Ödeme Talimatı
                <Image src={PAYCELL_LOGO} size='small' floated='right' />
            </Modal.Header>
            <Modal.Content>
                <Order closeModal={handleCloseOrderModal} callerMsisdn={history.location.state.callerMsisdn} invoice={history.location.state.invoice}/>
            </Modal.Content>
      </Modal>

      {
        (typeof history.location.state.paymentResult == "undefined" || history.location.state.paymentResult.operationResult.resultCode !== '0' ) ?
          (
              <ResultFail paymentResult={history.location.state.paymentResult} invoice={history.location.state.invoice}/>
          ) :
          (
            <ResultSuccess paymentResult={history.location.state.paymentResult} invoice={history.location.state.invoice}/>
          )
      }

      <br/>

      <div style={{textAlign:'center'}}>
        {
          !isExternalSdk() && orderActive &&
          <button className={styles.button} style={getButtonStyle()} onClick={() => setOpenOrderModal(true)} >Fatura ödeme talimatı vermek için tıklayınız</button>
        }
      </div>

      <br/>

      {
        receiptImage &&
        <a href={receiptImage.toUrl} target='_blank'>
          <Image src={`data:image/jpeg;base64,${receiptImage.image}`} className={styles.imageContainer}/>
        </a>
      }
      {
        offerImage &&
        <Modal
          onClose={() => setShowOffer(false)}
          onOpen={() => setShowOffer(true)}
          open={showOffer}
          dimmer='blurring'
          closeIcon
          size='tiny'>
            <Modal.Content image>
              <a href={offerImage.toUrl} target='_blank'>
                <Image  src={`data:image/jpeg;base64,${offerImage.image}`}/>
              </a>
            </Modal.Content>
        </Modal>
      }

      {
        !isExternalSdk() &&
        <div style={{position:"fixed",bottom:0,width:'100%'}}>
          <Segment inverted vertical>
            <Footer/>
          </Segment>
        </div>
      }
    </div>
  )
}

export default Result
